import { render } from "./UploadAvatar.vue?vue&type=template&id=7f6f62fe&scoped=true&ts=true"
import script from "./UploadAvatar.vue?vue&type=script&lang=ts"
export * from "./UploadAvatar.vue?vue&type=script&lang=ts"

import "./UploadAvatar.vue?vue&type=style&index=0&id=7f6f62fe&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6f62fe"]])

export default __exports__